import { DEFAULT_SPACE_COLOR } from "../../../../../constants/space";
import { useUpdateUserCalendarMutation } from "../../../../../react-query/userCalendars/mutations";
import CalendarVisibilityCheckBox from "../../../../atom/Common/CalendarVisibilityCheckbox";

const CalendarListItem = ({
  isSelected,
  calendarId,
  calendarName,
  color,
  onClick,
}: {
  calendarId: number;
  isSelected: boolean;
  calendarName: string;
  color: string;
  onClick: (calendarId: number) => void;
}) => {
  const handleClick = () => {
    onClick(calendarId);
  };

  return (
    <div
      className="flex h-9 px-[6px] py-0.5 items-center gap-2 self-stretch hover:bg-w-8-hover cursor-pointer rounded-[5px] text-body1"
      onClick={handleClick}
    >
      <CalendarVisibilityCheckBox
        isSelected={isSelected}
        baseColor={color ?? DEFAULT_SPACE_COLOR}
        size={16}
        checkColor="#1a1c1c"
        borderRadius="5px"
      />
      <p> {calendarName}</p>
    </div>
  );
};

export default CalendarListItem;
